module.exports = __webpack_public_path__ + "static/media/03en.6c7b05dc.jpg";